// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__KxPqU","spin":"styles_spin__1xRH2"};